import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'
import { ResponsiveSVG } from 'ui/acro'
import Text from 'ui/acro/typography/Text'
import ShareIcon from '../images/latest/share_icon.svg'
import FacebookMark from '../images/latest/facebook.svg'
import closeSVG from '../../assets/images/X.svg'

const TriggerButton = styled.button`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: #000;
`

const TriggerLabel = styled(Text)({
  fontSize: ['14px'],
  fontFamily: 'Proxima-nova',
  fontWeight: 400,
  lineHeight: '18px',
  letterSpacing: '0.308px'
})

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10050;
  background: rgba(0, 0, 0, 0.5);
`

const Sheet = styled.div`
  position: fixed;
  z-index: 10051;
  background: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media (max-width: 767px) {
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 8px 8px 0 0;
    max-height: 85vh;
  }

  @media (min-width: 768px) {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 496px;
    max-width: calc(100vw - 32px);
    box-shadow: 0 4px 12px rgba(35, 41, 54, 0.08), 0 2px 6px rgba(0, 0, 0, 0.06);
  }
`

const SheetHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 38px 16px 16px;
  flex-shrink: 0;
`

const SheetTitle = styled.p`
  margin: 0;
  font-family: 'Proxima-nova', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.352px;
  color: #000;
`

const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  line-height: 0;
`

const OptionsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 14px 13px 24px;
  flex: 1;
  min-height: 0;

  @media (min-width: 768px) {
    padding: 17px 63px 32px;
    width: 100%;
    box-sizing: border-box;
  }
`

const Option = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 71px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-family: 'Proxima-nova', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.308px;
  color: #000;
`

const IconCircle = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid #000;
  box-sizing: border-box;
  flex-shrink: 0;

  svg {
    display: block;
  }
`

const LinkGlyph = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden
  >
    <path
      d='M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z'
      fill='#000'
    />
  </svg>
)

const MessageGlyph = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden
  >
    <path
      d='M35 25C35 25.8841 34.6488 26.7319 34.0237 27.357C33.3986 27.9821 32.5507 28.3333 31.6667 28.3333H11.6667L5 35V8.33333C5 7.44928 5.35119 6.60143 5.97631 5.97631C6.60143 5.35119 7.44928 5 8.33333 5H31.6667C32.5507 5 33.3986 5.35119 34.0237 5.97631C34.6488 6.60143 35 7.44928 35 8.33333V25Z'
      stroke='#000'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

const EmailGlyph = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden
  >
    <path
      d='M6.66634 6.66669H33.333C35.1663 6.66669 36.6663 8.16669 36.6663 10V30C36.6663 31.8334 35.1663 33.3334 33.333 33.3334H6.66634C4.83301 33.3334 3.33301 31.8334 3.33301 30V10C3.33301 8.16669 4.83301 6.66669 6.66634 6.66669Z'
      stroke='#000'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M36.6663 10L19.9997 21.6667L3.33301 10'
      stroke='#000'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export function appendShareUtm(url, source) {
  if (!url || typeof url !== 'string') {
    return typeof window !== 'undefined' ? window.location.href : ''
  }
  try {
    const u = new URL(url)
    u.searchParams.set('utm_source', source)
    u.searchParams.set('utm_medium', 'social_share')
    u.searchParams.set('utm_campaign', 'content_page')
    return u.toString()
  } catch (e) {
    return url
  }
}

async function writeClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text)
    return
  }
  const ta = document.createElement('textarea')
  ta.value = text
  ta.style.position = 'fixed'
  ta.style.left = '-9999px'
  document.body.appendChild(ta)
  ta.select()
  try {
    document.execCommand('copy')
  } finally {
    document.body.removeChild(ta)
  }
}

export function ShareActionTrigger({ onClick, ariaExpanded }) {
  return (
    <TriggerButton
      type='button'
      data-pdp-share-trigger
      aria-haspopup='dialog'
      aria-expanded={ariaExpanded}
      onClick={onClick}
    >
      <ResponsiveSVG SVG={ShareIcon} width='24px' height='24px' />
      <TriggerLabel>Share</TriggerLabel>
    </TriggerButton>
  )
}

export function ShareOptionsSheet({
  open,
  onClose,
  shareUrl,
  shareTitle,
  contentType = 'CLASS'
}) {
  const [copied, setCopied] = useState(false)
  const type = contentType === 'SERIES' ? 'SERIES' : 'CLASS'
  const shareLine =
    type === 'SERIES'
      ? `Check out the program “${shareTitle}” on ALO Wellness Club`
      : `Check out “${shareTitle}” on ALO Wellness Club`

  useEffect(() => {
    if (!open) return undefined
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    const onKey = (e) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    return () => {
      document.body.style.overflow = prev
      document.removeEventListener('keydown', onKey)
    }
  }, [open, onClose])

  useEffect(() => {
    if (!open) setCopied(false)
  }, [open])

  const openFacebook = () => {
    const url = appendShareUtm(shareUrl, 'facebook')
    const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      url
    )}`
    window.open(
      fbUrl,
      'facebook-share-dialog',
      'width=626,height=436,noopener,noreferrer'
    )
    onClose()
  }

  const openMessage = () => {
    const url = appendShareUtm(shareUrl, 'sms')
    window.location.href = `sms:?&body=${encodeURIComponent(
      `${shareLine} ${url}`
    )}`
    onClose()
  }

  const openEmail = () => {
    const url = appendShareUtm(shareUrl, 'email')
    const subject =
      type === 'SERIES'
        ? 'Check out this program on ALO Wellness Club'
        : 'Check out this class on ALO Wellness Club'
    window.location.href = `mailto:?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(`${shareLine} ${url}`)}`
    onClose()
  }

  const copyLink = async () => {
    const url = appendShareUtm(shareUrl, 'copy_link')
    try {
      await writeClipboard(`${shareLine} ${url}`)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (e) {
      console.error(e)
    }
  }

  if (!open) return null

  const sheet = (
    <>
      <Backdrop role='presentation' onClick={onClose} aria-hidden='true' />
      <Sheet
        role='dialog'
        aria-modal='true'
        aria-labelledby='content-share-title'
        onClick={(e) => e.stopPropagation()}
      >
        <SheetHeader>
          <SheetTitle id='content-share-title'>Share</SheetTitle>
          <CloseBtn type='button' onClick={onClose} aria-label='Close'>
            <ResponsiveSVG SVG={closeSVG} width='20px' height='20px' />
          </CloseBtn>
        </SheetHeader>
        <OptionsRow>
          <Option type='button' onClick={openFacebook}>
            <IconCircle>
              <ResponsiveSVG SVG={FacebookMark} width='22px' height='22px' />
            </IconCircle>
            Facebook
          </Option>
          <Option type='button' onClick={openMessage}>
            <IconCircle>
              <MessageGlyph />
            </IconCircle>
            Message
          </Option>
          <Option type='button' onClick={openEmail}>
            <IconCircle>
              <EmailGlyph />
            </IconCircle>
            Email
          </Option>
          <Option type='button' onClick={copyLink}>
            <IconCircle>
              <LinkGlyph />
            </IconCircle>
            {copied ? 'Copied!' : 'Copy Link'}
          </Option>
        </OptionsRow>
      </Sheet>
    </>
  )

  return ReactDOM.createPortal(sheet, document.body)
}

const ContentShareButton = (props) => {
  const shareUrl = props.shareUrl ?? props.share_url
  const shareTitle = props.shareTitle ?? props.share_title ?? ''
  const contentType = props.contentType ?? props.content_type ?? 'CLASS'
  const [open, setOpen] = useState(false)

  return (
    <>
      <ShareActionTrigger onClick={() => setOpen(true)} ariaExpanded={open} />
      <ShareOptionsSheet
        open={open}
        onClose={() => setOpen(false)}
        shareUrl={shareUrl}
        shareTitle={shareTitle}
        contentType={contentType}
      />
    </>
  )
}

export default ContentShareButton
